import { Web3Provider } from '@ethersproject/providers'
import { Address } from '../../../types'
import { Interface } from '@ethersproject/abi'
import { FunctionFragment } from '@ethersproject/abi/src.ts/fragments'
import { Contract } from '@ethersproject/contracts'
import { multicallAbi } from '../../../abi'

interface MulticallData {
  success: boolean
  returnData: string
}

export async function sendMulticall<T>(
  provider: Web3Provider,
  multicallContract: Address,
  callAddresses: Address[],
  calls: any[],
): Promise<{
  blockNumber: string
  returnData: Array<MulticallData>
  decode: (iface: Interface, fragment: FunctionFragment) => Array<T>
}> {
  try {
    const contract = new Contract(multicallContract, multicallAbi, provider)
    const tx = await contract.multiStaticCall(callAddresses, calls)

    const [blockNumber, returnData] = tx

    return {
      blockNumber: Number(blockNumber).toString(16),
      returnData,
      decode: ((data: Array<MulticallData>) => {
        return (iface: Interface, fragment: FunctionFragment) => {
          return decodeMulticallData<T>(iface, fragment, data)
        }
      })(returnData),
    }
  } catch (e) {
    return {
      blockNumber: '0x0',
      returnData: [],
      decode: () => {
        return []
      },
    }
  }
}

export function decodeMulticallData<T>(
  iface: Interface,
  fragment: FunctionFragment,
  returnData: Array<MulticallData>,
): Array<T> {
  return returnData.map(({ success, returnData }) => {
    if (!success) {
      return null
    }
    return iface.decodeFunctionResult(fragment, returnData)[0]
  })
}
